import { createSlice } from "@reduxjs/toolkit";

const initialUseradd = JSON.parse(localStorage.getItem("addresses"));
const addSlice = createSlice({
  name: "address",
  initialState: {
    addresses: initialUseradd || [],
    changed: false,
    defaultShipAdd: [],
  },
  reducers: {
    getAdd(state, action) {
      const addreses = action.payload;
      state.addresses = addreses;
      state.changed = false;
      const shippingadd = addreses.filter((add) => add.isDefaultAddress);
      state.defaultShipAdd = shippingadd;
      localStorage.setItem("addresses", JSON.stringify(state.addresses));
    },
    addDataChanged(state) {
      state.changed = true;
    },
    delAdd(state) {
      state.changed = true;
    },
    addOrUpdate(state) {
      state.changed = true;
    },
    updateDefaultShipAdd(state) {
      state.changed = true;
    },
  },
});

export const addAction = addSlice.actions;

export default addSlice;
